module.exports = __webpack_public_path__ + "img/icon_mypage.253544d7.svg";